"use client";

import { useTranslation } from "react-i18next";
import { PhoneCall } from "lucide-react";
import { useBookingCta, useBookingImpression } from "@/features/booking/use-booking-cta";

/**
 * Custom-deployment escape hatch for paywall/upgrade dialogs: a one-line
 * pitch + the unified copy-arm CTA for sales-qualified users. Renders null
 * for everyone else, so every existing paywall variant is unchanged for
 * the self-serve audience.
 */
export function PaywallCustomPath() {
  const { t } = useTranslation();
  const cta = useBookingCta("paywall");
  useBookingImpression(cta, "paywall", cta.qualified);

  if (!cta.qualified) return null;

  return (
    <p className="text-center text-xs text-muted-foreground" data-testid="paywall-custom-path">
      {t("PAYWALL.CUSTOM_PATH", "Need white-label, custom scoring, or a dedicated build? We do that.")}{" "}
      <a
        href={cta.href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={cta.trackClick}
        className="inline-flex items-center gap-1 rounded-sm font-medium text-primary underline hover:text-primary/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        data-testid="paywall-custom-path-cta"
      >
        <PhoneCall className="h-3 w-3" aria-hidden="true" />
        {t(cta.label.key, cta.label.text)}
      </a>
    </p>
  );
}
